import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/mm-js/mm-js/applications/voting/src/app/Home.tsx");
